import { useLoginStore } from '@/store/LoginStore'

/**
 * 인증 관련 상태와 기능을 관리하는 커스텀 훅입니다.
 * useLoginStore를 직접 호출하는 대신 이 훅을 사용하여 추상화된 상태를 참조하세요.
 */
export const useAuth = () => {
    // Selector 패턴을 사용하여 필요한 값만 구독 (성공적인 불필요한 재렌더링 방지)
    const accessToken = useLoginStore((state) => state.accessToken)
    const logout = useLoginStore((state) => state.logout)

    return {
        accessToken,
        logout,
        /** 로그인 여부 (accessToken이 존재하는지 확인) */
        isLoggedIn: !!accessToken
    }
}
